export default "__VITE_ASSET__1cbe576c__"